export const jobSubtypeCodes = {
  POSSalesOrder: 'JobType_POSSO',
  LayawayOrder: 'JobType_POS_LSO',
  CustomOrderJO: 'JobType_POS_COJO',
  CustomOrderPQ: 'JobType_POS_COPQ',
  RepairJobOrder: 'JobType_REPJO',
  RepairPriceQuote: 'JobType_REPPQ',
}
